import { ComponentProps } from 'react'
import classnames from 'classnames'
import { Icon } from '../Icon/Icon'

type PillProps = {
    value?: number
    icon?: ComponentProps<typeof Icon>['name']
}

export const Pill: React.FC<PillProps> = ({ value, icon }) => {
    if (typeof value !== 'number') {
        return null
    }

    const pillClasses = classnames(
        'text-label-xsmall inline-flex min-w-6 items-center justify-center rounded-full border border-blue-100 bg-blue-50 text-regular gap-0.5 px-2 py-[3px]'
    )

    return (
        <span className={pillClasses} data-testid="pill-container">
            {value}
            {icon && (
                <Icon
                    name={icon}
                    className="text-icon-small text-azure"
                    data-testid="pill-icon"
                />
            )}
        </span>
    )
}
